<template>
  <!-- 切记 这个table不能加任何 class 和 id -->
  <table v-if="treeData">
    <tr>
      <td
        :colspan="
          Array.isArray(treeData.childOrganizations) ? treeData.childOrganizations.length * 2 : 1
        "
        :class="{
          parentLevel:
            Array.isArray(treeData.childOrganizations) && treeData.childOrganizations.length,
          extend:
            Array.isArray(treeData.childOrganizations) &&
            treeData.childOrganizations.length &&
            treeData.extend,
        }"
      >
        <div :class="{ node: true, hasMate: treeData.mate }">
          <div
            class="person"
            :class="Array.isArray(treeData.class) ? treeData.class : []"
            @click="$emit('click-node', treeData)"
          >
            <div class="avat text-left overflow-hidden">
              <div v-if="treeData.organizationName" class="text-center h-21px">
                {{ treeData.organizationName }}
              </div>
              <template v-if="treeData.roles">
                <div
                  v-for="(treeItem, treeIndex) in treeData.roles"
                  :key="treeIndex"
                  class="pl-10px truncate h-[calc(100%-21px)] flex w-full"
                >
                  <div v-if="treeItem.roleName">{{ treeItem.roleName }}:</div>
                  <div class="w-full whitespace-normal">{{ treeItem.userName }}</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </td>
    </tr>
    <tr
      v-if="
        Array.isArray(treeData.childOrganizations) &&
          treeData.childOrganizations.length &&
          treeData.extend
      "
    >
      <td
        v-for="(children, index) in treeData.childOrganizations"
        :key="index"
        colspan="2"
        class="childLevel"
      >
        <TreeChart :json="children" @click-node="$emit('click-node', $event)" />
      </td>
    </tr>
  </table>
</template>

<script>
export default {
  name: 'TreeChart',
  props: ['json'],
  data() {
    return {
      treeData: {},
    }
  },
  watch: {
    json: {
      handler(Props) {
        if (Props) {
          this.treeData = this.extendKey(Props)
        }
      },
      immediate: true,
    },
  },
  methods: {
    extendKey(jsonData) {
      jsonData.extend = jsonData.extend === void 0 ? true : !!jsonData.extend
      if (Array.isArray(jsonData.childOrganizations)) {
        jsonData.childOrganizations.forEach((c) => {
          this.extendKey(c)
        })
      }
      return jsonData
    },
  },
}
</script>

<style scoped>
table {
  border-collapse: separate !important;
  border-spacing: 0 !important;
}
td {
  position: relative;
  vertical-align: top;
  padding: 0 0 20px 0;
  text-align: center;
}

.extend .extend_handle:before {
  transform: rotateZ(-45deg);
}

.extend::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 15px;
  height: 50px;
  border-left: 2px solid var(--collapseBorder);
  transform: translate3d(-1px, 0, 0);
}
.childLevel::before {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 100%;
  height: 15px;
  border-left: 2px solid var(--collapseBorder);
  transform: translate3d(-1px, 0, 0);
}
.childLevel::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  top: -15px;
  border-top: 2px solid var(--collapseBorder);
}
.childLevel:first-child:before,
.childLevel:last-child:before {
  display: none;
}
.childLevel:first-child:after {
  left: 50%;
  height: 15px;
  border: 2px solid;
  border-color: var(--collapseBorder) transparent transparent var(--collapseBorder);
  border-radius: 6px 0 0 0;
  transform: translate3d(1px, 0, 0);
}
.childLevel:last-child:after {
  right: 50%;
  height: 15px;
  border: 2px solid;
  border-color: var(--collapseBorder) var(--collapseBorder) transparent transparent;
  border-radius: 0 6px 0 0;
  transform: translate3d(-1px, 0, 0);
}
.childLevel:first-child.childLevel:last-child::after {
  left: auto;
  border-radius: 0;
  border-color: transparent var(--collapseBorder) transparent transparent;
  transform: translate3d(1px, 0, 0);
}

.node {
  position: relative;
  display: inline-block;
  margin: 0 1em;
  box-sizing: border-box;
  text-align: center;
}
.node .person {
  position: relative;
  display: inline-block;
  z-index: 2;
  width: 15em;
  overflow: hidden;
}
.node .person .avat {
  display: block;
  width: 15em;
  height: 6em;
  margin: auto;
  overflow: hidden;
  background: var(--contentBgColor);
  border: 1px solid var(--collapseBorder);
  box-sizing: border-box;
}

.node .person .name {
  height: 2em;
  line-height: 2em;
  overflow: hidden;
  width: 100%;
}
.node.hasMate::after {
  content: '';
  position: absolute;
  left: 2em;
  right: 2em;
  top: 2em;
  border-top: 2px solid var(--collapseBorder);
  z-index: 1;
}
/* 横板 */
.landscape {
  transform: translate(-100%, 0) rotate(-90deg);
  transform-origin: 100% 0;
}
.landscape .node {
  text-align: left;
  height: 8em;
  width: 8em;
}
.landscape .person {
  position: relative;
  transform: rotate(90deg);
  padding-left: 4.5em;
  height: 4em;
  top: 4em;
  left: -1em;
}
.landscape .person .avat {
  position: absolute;
  left: 0;
}
.landscape .person .name {
  height: 4em;
  line-height: 4em;
}
.landscape .hasMate {
  position: relative;
}
.landscape .hasMate .person {
  position: absolute;
}
.landscape .hasMate .person:first-child {
  left: auto;
  right: -4em;
}
.landscape .hasMate .person:last-child {
  left: -4em;
  margin-left: 0;
}
</style>
